<template>
    <div class="flex flex-col">
        <div class="-m-1.5 overflow-x-auto">
            <div
                :class="{ 'min-w-full': fullWidth }"
                class="p-1.5 inline-block align-middle"
            >
                <div
                    class="border border-stone-200 shadow-xs rounded-lg2 overflow-hidden"
                >
                    <table
                        :class="{ 'min-w-full': fullWidth }"
                        class="divide-y divide-gray-200"
                    >
                        <slot />
                    </table>
                    <template v-if="isEmpty">
                        <slot name="emptyState" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        isEmpty: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: true,
        },
    })
</script>
